import { useEffect } from "react";
import { selectIsEventManager } from "modules/event/selectors";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { selectCurrentTheaterId } from "modules/theater/selectors";
import classNames from "classnames";
import { selectShowTimer, selectTimerParams } from "../../redux/selectors";
import { TimerManagerPanel } from "../TimerManagerPanel";
import { TimerPanel } from "../TimerPanel";
import timerFirebase from "../../timer.firebase";
import { resetTimer, setupTimer, timerSetupActive } from "../../redux/slice";
import { useStyles } from "./styles";

export const TimerPanelContainer = () => {
  const isEventManager = useSelector(selectIsEventManager);
  const theaterId = useSelector(selectCurrentTheaterId);
  const dispatch = useAppDispatch();
  const showTimerPanel = useSelector(selectShowTimer);
  const styles = useStyles();
  const { startedAt, breakDuration, roundDuration, rounds } =
    useSelector(selectTimerParams);

  useEffect(() => {
    if (theaterId === null) {
      return;
    }
    timerFirebase.subscribe(theaterId, (timerParams) => {
      dispatch(setupTimer(timerParams));
    });

    // eslint-disable-next-line consistent-return
    return () => timerFirebase.unsubscribe(theaterId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theaterId]);

  return (
    <div
      data-testid="timer-panel-container"
      className={classNames(styles.timerContainer, {
        [styles.hideTimer]: !showTimerPanel,
      })}
    >
      <TimerPanel
        startedAt={startedAt}
        breakDuration={breakDuration}
        roundDuration={roundDuration}
        rounds={rounds}
        isEventManager={isEventManager}
        onStart={() => {
          if (isEventManager) {
            dispatch(timerSetupActive());
          }
        }}
        onEnd={() => {
          dispatch(resetTimer());
        }}
      />
      {isEventManager && <TimerManagerPanel />}
    </div>
  );
};
